// loader
document.addEventListener("DOMContentLoaded", () => {
  const loader = document.querySelector('.loader-mask');
  loader.classList.add('fade-out');
  setTimeout(() => loader.classList.add('lottieLoader'), 3500);
});

// Loader all page
window.addEventListener("load", function () {
  // $('.loader').fadeOut();
  // $('.loader-mask').delay(400).fadeOut('slow');

  if (document.body.querySelector(".product")) {
    window.addEventListener("scroll", function() {
      const element = document.querySelector(".product"); // change selector
      const scrollPosition = window.scrollY || document.documentElement.scrollTop;

      if (scrollPosition > 100) {
        element.classList.add("scrolled"); // add your class
      } else {
        element.classList.remove("scrolled"); // remove your class
      }
    });
  }

});

// menu
function menuBtnFunction(menuBtn) {
  const header = document.getElementById('header');
  const mainmenu = document.getElementById('main-menu');
  menuBtn.classList.toggle("active");
  header.classList.toggle("open");
  mainmenu.classList.toggle("open");

  document.body.classList.toggle("menu-open");
    // Toggle button text
  if (menuBtn.classList.contains("active")) {
      menuBtn.childNodes[0].nodeValue = "Close";
      document.querySelector(".logo").classList.add("white-logo");
      //document.getElementById('logo').src = 'image/logo.svg';
  } else {
      menuBtn.childNodes[0].nodeValue = "Menu";
      //document.getElementById('logo').src = 'image/black-logo.svg';
      document.querySelector(".logo").classList.remove("white-logo");
  }
}

// navbar
let lastScrollTop = 0;
const targetElement = document.querySelector('.header'); // Replace with your selector
const className = 'scrolled'; // Class to toggle

window.addEventListener('scroll', () => {
  const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

  if (currentScroll > lastScrollTop) {
    // Scrolling down
    targetElement.classList.add('fixed');
    //document.getElementById('logo').src = 'image/black-logo.svg';
  } else {
    // Scrolling up
    targetElement.classList.remove('fixed');
    //document.getElementById('logo').src = 'image/black-logo.svg';
  }

  // lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // For mobile/browser compatibility
});

// back to top
const backToTopBtn = document.getElementById('backToTop');

window.addEventListener('scroll', () => {
  if (window.scrollY > 300) {
    backToTopBtn.classList.add('show');
  } else {
    backToTopBtn.classList.remove('show');
  }
});

backToTopBtn.addEventListener('click', () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
});

// wow
(function() {
  var Util,
    __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  Util = (function() {
    function Util() {}

    Util.prototype.extend = function(custom, defaults) {
      var key, value;
      for (key in custom) {
        value = custom[key];
        if (value != null) {
          defaults[key] = value;
        }
      }
      return defaults;
    };

    Util.prototype.isMobile = function(agent) {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(agent);
    };

    return Util;

  })();

  this.WOW = (function() {
    WOW.prototype.defaults = {
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true
    };

    function WOW(options) {
      if (options == null) {
        options = {};
      }
      this.scrollCallback = __bind(this.scrollCallback, this);
      this.scrollHandler = __bind(this.scrollHandler, this);
      this.start = __bind(this.start, this);
      this.scrolled = true;
      this.config = this.util().extend(options, this.defaults);
    }

    WOW.prototype.init = function() {
      var _ref;
      this.element = window.document.documentElement;
      if ((_ref = document.readyState) === "interactive" || _ref === "complete") {
        return this.start();
      } else {
        return document.addEventListener('DOMContentLoaded', this.start);
      }
    };

    WOW.prototype.start = function() {
      var box, _i, _len, _ref;
      this.boxes = this.element.getElementsByClassName(this.config.boxClass);
      if (this.boxes.length) {
        if (this.disabled()) {
          return this.resetStyle();
        } else {
          _ref = this.boxes;
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            box = _ref[_i];
            this.applyStyle(box, true);
          }
          window.addEventListener('scroll', this.scrollHandler, false);
          window.addEventListener('resize', this.scrollHandler, false);
          return this.interval = setInterval(this.scrollCallback, 50);
        }
      }
    };

    WOW.prototype.stop = function() {
      window.removeEventListener('scroll', this.scrollHandler, false);
      window.removeEventListener('resize', this.scrollHandler, false);
      if (this.interval != null) {
        return clearInterval(this.interval);
      }
    };

    WOW.prototype.show = function(box) {
      this.applyStyle(box);
      return box.className = "" + box.className + " " + this.config.animateClass;
    };

    WOW.prototype.applyStyle = function(box, hidden) {
      var delay, duration, iteration;
      duration = box.getAttribute('data-wow-duration');
      delay = box.getAttribute('data-wow-delay');
      iteration = box.getAttribute('data-wow-iteration');
      return box.setAttribute('style', this.customStyle(hidden, duration, delay, iteration));
    };

    WOW.prototype.resetStyle = function() {
      var box, _i, _len, _ref, _results;
      _ref = this.boxes;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        box = _ref[_i];
        _results.push(box.setAttribute('style', 'visibility: visible;'));
      }
      return _results;
    };

    WOW.prototype.customStyle = function(hidden, duration, delay, iteration) {
      var style;
      style = hidden ? "visibility: hidden; -webkit-animation-name: none; -moz-animation-name: none; animation-name: none;" : "visibility: visible;";
      if (duration) {
        style += "-webkit-animation-duration: " + duration + "; -moz-animation-duration: " + duration + "; animation-duration: " + duration + ";";
      }
      if (delay) {
        style += "-webkit-animation-delay: " + delay + "; -moz-animation-delay: " + delay + "; animation-delay: " + delay + ";";
      }
      if (iteration) {
        style += "-webkit-animation-iteration-count: " + iteration + "; -moz-animation-iteration-count: " + iteration + "; animation-iteration-count: " + iteration + ";";
      }
      return style;
    };

    WOW.prototype.scrollHandler = function() {
      return this.scrolled = true;
    };

    WOW.prototype.scrollCallback = function() {
      var box;
      if (this.scrolled) {
        this.scrolled = false;
        this.boxes = (function() {
          var _i, _len, _ref, _results;
          _ref = this.boxes;
          _results = [];
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            box = _ref[_i];
            if (!(box)) {
              continue;
            }
            if (this.isVisible(box)) {
              this.show(box);
              continue;
            }
            _results.push(box);
          }
          return _results;
        }).call(this);
        if (!this.boxes.length) {
          return this.stop();
        }
      }
    };

    WOW.prototype.offsetTop = function(element) {
      var top;
      top = element.offsetTop;
      while (element = element.offsetParent) {
        top += element.offsetTop;
      }
      return top;
    };

    WOW.prototype.isVisible = function(box) {
      var bottom, offset, top, viewBottom, viewTop;
      offset = box.getAttribute('data-wow-offset') || this.config.offset;
      viewTop = window.pageYOffset;
      viewBottom = viewTop + this.element.clientHeight - offset;
      top = this.offsetTop(box);
      bottom = top + box.clientHeight;
      return top <= viewBottom && bottom >= viewTop;
    };

    WOW.prototype.util = function() {
      return this._util || (this._util = new Util());
    };

    WOW.prototype.disabled = function() {
      return !this.config.mobile && this.util().isMobile(navigator.userAgent);
    };

    return WOW;

  })();

}).call(this);


wow = new WOW(
  {
    animateClass: 'animated',
    offset: 100
  }
);
wow.init();


// scroll
// document.addEventListener('DOMContentLoaded', () => {
//   const videoSection = document.querySelector('.video-section');
//   const heroImage = document.querySelector('.hero-counter-left img');
//   const videoo = document.getElementById('myVideo');

//   const observer = new IntersectionObserver(
//     ([entry]) => {
//       if (entry.isIntersecting) {
//         heroImage.classList.add('animate-hero-image');

//         if (videoo.paused) {
//           videoo.play();
//           setTimeout(() => {
//             videoo.style.opacity = '1';
//             heroImage.style.opacity = '0';
//           }, 1000); // 1000ms = 1 second delay
//         }
//       } else {
//         heroImage.classList.remove('animate-hero-image');
//         // Optional: fade image back in when video out of view
//         heroImage.style.opacity = '1'; videoo.style.opacity = '0'; videoo.pause();
//       }
//     },
//     {
//       threshold: 0.3, // Trigger when 30% of video is visible
//     }
//   );

//   if (videoSection && heroImage && videoo) {
//     observer.observe(videoSection);
//   }
// });

// document.addEventListener('DOMContentLoaded', () => {
//   const videoSection = document.querySelector('.video-section');
//   const heroImage = document.querySelector('.hero-counter-left img');
//   const videoo = document.getElementById('myVideo');

//   let isAnimating = false;

//   const observer = new IntersectionObserver(
//     ([entry]) => {
//       if (entry.isIntersecting) {
//         videoo.play();
//         isAnimating = true;
//         requestAnimationFrame(updateTransform);
//       } else {
//         isAnimating = false;
//         heroImage.style.transform = '';
//         heroImage.style.opacity = '1';
//         videoo.style.opacity = '0';
//         videoo.pause();
//       }
//     },
//     { threshold: 0.3 }
//   );

//   function updateTransform() {
//     if (!isAnimating) return;

//     const rect = videoSection.getBoundingClientRect();
//     const windowHeight = window.innerHeight;
//     let progress = 1 - rect.top / windowHeight;
//     progress = Math.min(Math.max(progress, 0), 1); // clamp 0–1

//     // Compute transformation
//     const translateY = 535 * progress;
//     const scale = 1 + 8 * progress;
//     const imageOpacity = 1 - progress;
//     const videoOpacity = progress >= 1 ? 1 : 0;

//     // Apply transforms
//     heroImage.style.transform = `translateY(${translateY}px) scale(${scale})`;
//     heroImage.style.opacity = imageOpacity;

//     // Smooth transitions (use CSS below)
//     videoo.style.opacity = videoOpacity;

//     // Reverse fade: bring back image when video fades out
//     if (progress < 1) {
//       videoo.style.opacity = '0';
//     }

//     requestAnimationFrame(updateTransform);
//   }

//   if (videoSection && heroImage && videoo) {
//     observer.observe(videoSection);
//   }
// });



// video play
// document.addEventListener('DOMContentLoaded', () => {
//   const videoSection = document.getElementById('video');
//   const video = document.getElementById('myVideo');
//   const poster = document.querySelector('.hero-counter-left img');

//   videoSection.addEventListener('click', () => {
//     if (video.paused) {
//       video.play();
//       video.style.opacity = '1';
//       poster.style.opacity = '0';
//     }
//   });
// });

// counter
// document.addEventListener('DOMContentLoaded', () => {
//   const counters = document.querySelectorAll('.count-up');
//   const counterSection = document.querySelector('.hero-counter');
//   let counted = false;

//   const animateCounters = () => {
//     counters.forEach(counter => {
//       const target = +counter.getAttribute('data-target');
//       let current = 0;
//       const duration = 2000; // total duration in ms
//       const stepTime = Math.max(Math.floor(duration / target), 30); // time per step

//       const updateCount = () => {
//         if (current < target) {
//           current++;
//           counter.innerText = current;
//           setTimeout(updateCount, stepTime);
//         } else {
//           counter.innerText = target;
//         }
//       };

//       updateCount();
//     });
//   };

//   const observer = new IntersectionObserver(
//     ([entry]) => {
//       if (entry.isIntersecting && !counted) {
//         animateCounters();
//         counted = true;
//       }
//     },
//     { threshold: 0.3 }
//   );

//   if (counterSection) observer.observe(counterSection);
// });

// // text animation
// document.addEventListener('DOMContentLoaded', () => {
//   const slideUpElements = document.querySelectorAll('.slide-up');

//   const observer = new IntersectionObserver((entries) => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         entry.target.classList.add('visible');
//       } else {
//         entry.target.classList.remove('visible');
//       }
//     });
//   }, {
//     threshold: 0.1
//   });

//   slideUpElements.forEach(el => observer.observe(el));
// });

document.addEventListener('DOMContentLoaded', function () {
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.7 // 
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target); 
      }
    });
  }, observerOptions);

  const elements = document.querySelectorAll('.animate-on-scroll');
  elements.forEach(el => observer.observe(el));
});

document.querySelectorAll('.custom-select-wrapper').forEach(wrapper => {
  const select = wrapper.querySelector('.custom-select');
  const trigger = select.querySelector('.custom-select__trigger');
  const options = select.querySelectorAll('.custom-option');
  const span = trigger.querySelector('span');
  const hiddenInput = wrapper.nextElementSibling; // gets the input just after the wrapper

  trigger.addEventListener('click', () => {
    // Close all other dropdowns
    document.querySelectorAll('.custom-select').forEach(otherSelect => {
      if (otherSelect !== select) {
        otherSelect.classList.remove('open');
      }
    });

    // Toggle this dropdown
    select.classList.toggle('open');
  });

  options.forEach(option => {
    option.addEventListener('click', () => {
      const selectedOption = select.querySelector('.custom-option.selected');
      if (selectedOption) selectedOption.classList.remove('selected');
      option.classList.add('selected');
      span.textContent = option.textContent;
      select.classList.remove('open');

      // Update corresponding hidden input value
      if (hiddenInput && hiddenInput.classList.contains('custom-hidden-input')) {
        hiddenInput.value = option.dataset.value;
      }
    });
  });
});

// Close dropdowns on outside click
window.addEventListener('click', e => {
  document.querySelectorAll('.custom-select').forEach(select => {
    if (!select.contains(e.target)) {
      select.classList.remove('open');
    }
  });
});


$(document).ready(function () {
  // Function to get URL parameter
  function getParameterByName(name) {
    name = name.replace(/[\[\]]/g, "\\$&");
    let url = window.location.href;
    let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
    let results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  // Get 'tab' parameter from URL
  const tabParam = getParameterByName('tab');

  if(tabParam) {
    // Activate the tab from URL
    $('.filter-button').each(function() {
      if($(this).data('filter').toLowerCase() === tabParam.toLowerCase()) {
        $('.filter-button').removeClass('active');
        $(this).addClass('active');

        $('.product-row .collection-grid').hide();
        $('.product-row .collection-grid').filter(`[data-category="${$(this).data('filter')}"]`).show();
      }
    });
  }

  // Existing click functionality
  $('.filter-button').click(function () {
    const filter = $(this).data('filter');
    
    $('.filter-button').removeClass('active');
    $(this).addClass('active');
    
    $('.product-row .collection-grid').hide();
    $('.product-row .collection-grid').filter(`[data-category="${filter}"]`).show();
  });

  const $carousel = $("#beyond-library-home .video-carousel");
  if (!$carousel.length || $carousel.hasClass('owl-loaded')) return;

  let currentIndex = 0;
  let isPaused = false;
  let progressRAF = null;
  let youtubePlayers = [];
  let youtubeReady = false;
  let carouselStarted = false;

  const $dots = $("#beyond-library-home .custom-dots .dot");
  const $toggle = $("#beyond-library-home #video-toggle");

  // Check whether an element is currently visible
  function isVisible(element) {
    return !!(element && element.getClientRects().length);
  }

  // Get currently visible video or iframe
  function getActiveMedia(index) {

    const $item = $carousel.find('.owl-item').eq(index);

    const videos = $item.find('video').toArray();
    const iframes = $item.find('iframe').toArray();

    const video = videos.find(isVisible);

    if (video) {
      return { type: 'video', element: video };
    }

    const iframe = iframes.find(isVisible);

    if (iframe) {
      return {
        type: 'youtube',
        element: iframe,
        player: youtubePlayers.find(p => p.iframe === iframe)?.player
      };
    }

    return null;
  }

  // Update play/pause icon
  function updatePlayPauseIcon() {

    if (isPaused) {
      $toggle.addClass('isPlay');
    } else {
      $toggle.removeClass('isPlay');
    }
  }

  // Stop progress animation
  function stopProgress() {
    cancelAnimationFrame(progressRAF);
    progressRAF = null;
  }

  // Reset progress
  function resetProgress() {

    stopProgress();

    $dots.find('.progress')
      .css('width', '0%')
      .hide();
  }

  // Move to next slide
  function nextSlide() {

    if (currentIndex < $carousel.find('.owl-item').length - 1) {

      $carousel.trigger('to.owl.carousel', [
        currentIndex + 1,
        700,
        true
      ]);

    } else {

      // Stop at last slide
      isPaused = true;
      updatePlayPauseIcon();
    }
  }

  // Get current playback progress
  function getPlaybackProgress(media) {

    if (!media) return null;

    if (media.type === 'video') {

      const video = media.element;

      if (!video.duration || !isFinite(video.duration)) return null;

      return {
        current: video.currentTime,
        duration: video.duration
      };
    }

    if (media.player && media.player.getDuration) {

      const duration = media.player.getDuration();

      if (!duration) return null;

      return {
        current: media.player.getCurrentTime(),
        duration: duration
      };
    }

    return null;
  }

  // Animate progress using actual video time
  function animateProgress(index) {

    stopProgress();

    const $progress = $dots.eq(index).find('.progress');

    $progress.css('width', '0%').show();

    function step() {

      if (isPaused || index !== currentIndex) return;

      const media = getActiveMedia(index);
      const playback = getPlaybackProgress(media);

      if (playback) {

        const percent = Math.min(
          (playback.current / playback.duration) * 100,
          100
        );

        $progress.css('width', percent + '%');
      }

      progressRAF = requestAnimationFrame(step);
    }

    progressRAF = requestAnimationFrame(step);
  }

  // Pause all videos and YouTube players
  function pauseAllMedia() {

    $carousel.find('video').each(function () {
      this.pause();
    });

    youtubePlayers.forEach(function (item) {
      if (item.player && item.player.pauseVideo) {
        item.player.pauseVideo();
      }
    });
  }

  // Reset all videos
  function resetAllVideos() {

    $carousel.find('video').each(function () {

      this.pause();

      try {
        this.currentTime = 0;
      } catch (e) {}

    });
  }

  // Play current slide
  function playVideoAt(index) {

    if (index < 0 || index >= $carousel.find('.owl-item').length) return;

    currentIndex = index;

    stopProgress();
    resetProgress();
    pauseAllMedia();

    const media = getActiveMedia(index);

    if (!media) return;

    isPaused = false;
    updatePlayPauseIcon();

    if (media.type === 'video') {

      const video = media.element;

      function startVideo() {

        if (index !== currentIndex) return;

        const playPromise = video.play();

        if (playPromise !== undefined) {

          playPromise.then(function () {

            if (index === currentIndex) {
              isPaused = false;
              updatePlayPauseIcon();
              animateProgress(index);
            }

          }).catch(function (error) {

            console.warn('Video autoplay blocked:', error);

            isPaused = true;
            updatePlayPauseIcon();

          });

        }
      }

      if (video.readyState >= 1) {
        startVideo();
      } else {
        video.addEventListener('loadedmetadata', startVideo, { once: true });
        video.load();
      }

    } else if (media.type === 'youtube') {

      const player = media.player;

      if (player && youtubeReady) {
        player.seekTo(0, true);
        player.playVideo();
        animateProgress(index);
      }
    }

    $dots.removeClass('active')
      .eq(index).addClass('active');
  }

  // Uploaded video ended
  $carousel.find('video').each(function () {

    this.addEventListener('ended', function () {

      if (!isPaused && getActiveMedia(currentIndex)?.element === this) {
        nextSlide();
      }

    });

  });

  // Initialize Owl Carousel
  $carousel.owlCarousel({

    items: 1,
    loop: false,
    dots: false,
    nav: false,
    smartSpeed: 700,
    margin: 0,
    stagePadding: 0,

    responsive: {
      0: {
        stagePadding: 30,
        margin: 10
      },
      768: {
        stagePadding: 0,
        margin: 20
      },
      1000: {
        stagePadding: 0,
        margin: 20
      }
    }

  });

  // Slide changed
  $carousel.on('changed.owl.carousel', function (event) {

    if (!event.item) return;

    currentIndex = event.item.index;

    playVideoAt(currentIndex);

  });

  // Custom dots
  $dots.on('click', function () {

    const index = Number($(this).data('slide'));

    if (index !== currentIndex) {

      isPaused = false;

      $carousel.trigger('to.owl.carousel', [
        index,
        700,
        true
      ]);

    }

  });

  // Play / Pause button
  $toggle.on('click', function () {

    const media = getActiveMedia(currentIndex);

    if (!media) return;

    if (media.type === 'video') {

      const video = media.element;

      if (video.paused) {

        video.play().then(function () {
          isPaused = false;
          updatePlayPauseIcon();
          animateProgress(currentIndex);
        }).catch(function (error) {
          console.warn('Video play failed:', error);
        });

      } else {

        video.pause();
        isPaused = true;
        stopProgress();
        updatePlayPauseIcon();

      }

    } else if (media.type === 'youtube' && media.player) {

      const state = media.player.getPlayerState();

      if (state === 1) {

        media.player.pauseVideo();
        isPaused = true;
        stopProgress();

      } else {

        media.player.playVideo();
        isPaused = false;
        animateProgress(currentIndex);

      }

      updatePlayPauseIcon();

    }

  });

  // YouTube API
  function initializeYouTube() {

    const iframes = $carousel.find('iframe').toArray();

    if (!iframes.length) return;

    if (!window.YT || !window.YT.Player) {

      if (!document.querySelector(
        'script[src="https://www.youtube.com/iframe_api"]'
      )) {

        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';

        document.head.appendChild(tag);
      }

      const previousCallback = window.onYouTubeIframeAPIReady;

      window.onYouTubeIframeAPIReady = function () {

        if (typeof previousCallback === 'function') {
          previousCallback();
        }

        createYouTubePlayers();
      };

    } else {

      createYouTubePlayers();
    }

  }

  function createYouTubePlayers() {

    if (youtubeReady) return;

    youtubeReady = true;

    $carousel.find('iframe').each(function () {

      const iframe = this;

      const player = new YT.Player(iframe, {

        events: {

          onReady: function () {

            const index = $carousel.find('.owl-item')
              .index($(iframe).closest('.owl-item'));

            if (index === currentIndex && carouselStarted) {
              playVideoAt(currentIndex);
            }

          },

          onStateChange: function (event) {

            const index = $carousel.find('.owl-item')
              .index($(iframe).closest('.owl-item'));

            if (index !== currentIndex) return;

            if (event.data === YT.PlayerState.ENDED) {

              if (!isPaused) {
                nextSlide();
              }

            } else if (event.data === YT.PlayerState.PAUSED) {

              isPaused = true;
              stopProgress();
              updatePlayPauseIcon();

            } else if (event.data === YT.PlayerState.PLAYING) {

              isPaused = false;
              updatePlayPauseIcon();
              animateProgress(currentIndex);

            }

          }

        }

      });

      youtubePlayers.push({
        iframe: iframe,
        player: player
      });

    });

    const activeMedia = getActiveMedia(currentIndex);

    if (carouselStarted && activeMedia?.type === 'youtube') {
      playVideoAt(currentIndex);
    }

  }

  // Start carousel when visible
  const carouselEl = document.querySelector('#beyond-library-home');

  if (carouselEl) {

    const observer = new IntersectionObserver(function (entries) {

      entries.forEach(function (entry) {

        if (entry.isIntersecting && entry.intersectionRatio >= 0.65) {

          if (!carouselStarted) {

            carouselStarted = true;
            playVideoAt(currentIndex);

          }

        }

      });

    }, {
      threshold: [0, 0.65, 1]
    });

    observer.observe(carouselEl);

  }

  // Initialize YouTube
  initializeYouTube();

});


/* Move all section to div wrapper for design */
document.addEventListener("DOMContentLoaded", function() {
   
  if (!document.body.classList.contains('product')) return;
  // const startSection = document.querySelector('.shopify-section.video-slideshow');
  const startSection = document.querySelector('.shopify-section.video-on-scroll');
  const endSection = document.querySelector('.shopify-section.rich-text');

  if (startSection && endSection) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('custom-sections-wrapper');
    startSection.parentNode.insertBefore(wrapper, startSection);
    let current = startSection;
    while (current) {
      const next = current.nextElementSibling;
      wrapper.appendChild(current);
      if (current === endSection) break;
      current = next;
    }
  }
});

/* for remote template Move section to div wrapper for design */
document.addEventListener("DOMContentLoaded", function() {
  const startSection = document.querySelector('.shopify-section.sunroof-control');
  const endSection = document.querySelector('.shopify-section.rich-text.section-wrapper');

  if (startSection && endSection) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('custom-sections-wrapper');
    startSection.parentNode.insertBefore(wrapper, startSection);
    let current = startSection;
    while (current) {
      const next = current.nextElementSibling;
      wrapper.appendChild(current);
      if (current === endSection) break;
      current = next;
    }
  }
});

// $(document).on('mouseenter', 'label.variant-option__button-label', function() {
//   var $productImg = $('.media-gallery--carousel .product-media-container[aria-hidden="false"]').find("img");

//   var newImg = $(this).find('input').data('variant-img');
//   if (newImg != "") {
//     $productImg.attr('src', newImg);
//     $productImg.attr('srcset', newImg);
//     $productImg.attr('data_max_resolution', newImg);
//   }
// });

// $(document).on('mouseleave', 'label.variant-option__button-label', function() {
//   console.log("out");
  
//   var $productImg = $('.media-gallery--carousel .product-media-container[aria-hidden="false"]').find("img");
//   var defaultImg = $productImg.attr('src');

//    $productImg.attr('src', defaultImg);
//    $productImg.attr('srcset', defaultImg);
//    $productImg.attr('data_max_resolution', defaultImg);
// });


$(document).ready(function () {
  function getVisibleImage() {
    return $('.media-gallery--carousel .product-media-container[aria-hidden="false"]').find('img').first();
  }

  function storeDefaultImage() {
    const $img = getVisibleImage();
    if ($img.length) {
      const currentSrc = $img.attr('src');
      if (currentSrc) {
        $img.attr('data-default-src', currentSrc);
      }
    }
  }

  storeDefaultImage();
  // --- hover in ---
  $(document).on('mouseenter', 'label.variant-option__button-label', function () {
    const newImg = $(this).find('input').attr('data-variant-img');
    if (newImg) {
      const $img = getVisibleImage();
      $img.attr({
        'src': newImg,
        'srcset': newImg,
        'data-max-resolution': newImg
      });
    }
  });

  // --- hover out (restore to original image) ---
  $(document).on('mouseleave', 'label.variant-option__button-label', function () {
    const $img = getVisibleImage();
    const defaultImg = $img.attr('data-default-src');
    if (defaultImg) {
      $img.attr({
        'src': defaultImg,
        'srcset': defaultImg,
        'data-max-resolution': defaultImg
      });
    }
  });

  $(document).on('change', '.variant-option__button-label input[type="radio"]', function () {
    $('.media-gallery--carousel img').removeAttr('data-default-src');
    setTimeout(function () {
      storeDefaultImage();
    }, 1000); 
  });
  
  const gallery = document.querySelector('.media-gallery--carousel');
  if (gallery && window.MutationObserver) {
    const observer = new MutationObserver(() => {
      setTimeout(storeDefaultImage, 500);
    });
    observer.observe(gallery, { childList: true, subtree: true });
  }
});

/* custom icon btn wrap in product page */
const buttons = document.querySelectorAll('.custom-icon-btn');

if (buttons.length > 1) {
  const wrapper = document.createElement('div');
  wrapper.className = 'custom-icon-btn-wrapper';
  const parent = buttons[0].parentNode;

  // Insert wrapper before first button
  parent.insertBefore(wrapper, buttons[0]);

  // Move all buttons into wrapper
  buttons.forEach(btn => wrapper.appendChild(btn));
}

/* product page white button wrap */
document.querySelectorAll('.pro-custom').forEach(parent => {
  const pricing = parent.querySelector('.pricing_doc_wrap');
  const download = parent.querySelector('.doc-download-btn-link');

  if (pricing && download) {
    if (!pricing.parentElement.classList.contains('pricing-download-wrapper') &&
        !download.parentElement.classList.contains('pricing-download-wrapper')) {

      const wrapper = document.createElement('div');
      wrapper.classList.add('pricing-download-wrapper');

      pricing.before(wrapper);

      wrapper.appendChild(pricing);
      wrapper.appendChild(download);
    }
  }
});

$(document).on('click', '.pop-close', function () {
    var $dialog = $(this).closest('dialog');
    $dialog.find('video').each(function () {
      this.pause();          // Pause the video
      this.currentTime = 0;  // Reset to start
    });
    $dialog.get(0).close()
  });

// Image spotlight
const imgLight = document.querySelectorAll(".window-room-one img");
function scrollImageLight() {
  window.innerWidth > 767 || imgLight.forEach((t => { const e = t.getBoundingClientRect(), a = window.innerHeight / 2; e.top < a && e.bottom > a ? t.style.opacity = 1 : (e.top, t.style.opacity = .5) }))
}
scrollImageLight(), window.addEventListener("scroll", scrollImageLight);

// js code change price format //
(function () {
  // --- Helpers ---
  function formatIndianInteger(intStr) {
    // remove leading zeros
    intStr = intStr.replace(/^0+(?=\d)/, '');
    if (intStr.length <= 3) return intStr;
    var last3 = intStr.slice(-3);
    var other = intStr.slice(0, -3);
    // insert commas every 2 digits in 'other' from right
    other = other.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
    return other + ',' + last3;
  }

  function formatNumberString(numStr) {
    // numStr like "312000.50" or "312000"
    if (!numStr) return numStr;
    var parts = numStr.split('.');
    var intPart = parts[0];
    var decPart = parts[1] !== undefined ? '.' + parts[1] : '';
    return formatIndianInteger(intPart) + decPart;
  }

  function formatMatchWithCurrency(match) {
    // match may contain currency symbol and/or spaces, e.g. "₹312,000.50" "₹ 312000" "312000₹"
    // We will preserve non-digit chars (like ₹) and only reformat the digits.
    // Extract digits+dot sequence
    var m = match.match(/[\d,]+(\.\d+)?/);
    if (!m) return match;
    var digits = m[0].replace(/,/g, '');
    var formattedDigits = formatNumberString(digits);
    return match.replace(m[0], formattedDigits);
  }

    // Process text nodes inside an element (preserve markup)
  function indianizeElement(el) {
    if (!el || el.nodeType !== 1) return;
    // Avoid reprocessing identical HTML repeatedly by marking time stamp
    try {
      var lastHtml = el.getAttribute('data-indian-last-html');
      var curHtml = el.innerHTML;
      if (lastHtml === curHtml) return; // nothing changed
      // do replacement for patterns like "₹ 312000", "₹312,000.50", "312000 ₹"
      // We'll replace occurrences that contain digits (with optional ₹ or Rs or INR)
      var newHtml = curHtml.replace(
        /(?:₹|Rs\.?|INR)?\s?[\d,]+(?:\.\d+)?\s?(?:₹)?|[\d,]+(?:\.\d+)?/g,
        function (match) {
          // We only want to format things that contain at least one digit
          if (!/[0-9]/.test(match)) return match;
          return formatMatchWithCurrency(match);
        }
      );
      if (newHtml !== curHtml) {
        el.innerHTML = newHtml;
      }
      el.setAttribute('data-indian-last-html', el.innerHTML);
    } catch (e) {
      // fail silently
      // console.error('indianizeElement', e);
    }
  }

  // List of selectors to target — add or remove according to your theme
  var selectors = [
    '.price',
    '.product__price',
    '.price-item',
    '.product-single__price',
    '.money',
    '[data-money]',
    '[data-price]',
    '.price-wrapper',
    '.product-price',
    '.cart__price',
    '.cart__subtotal',
    '.total-line__price',
    '.order-summary__emphasis',
  ];

  function collectElements() {
    var set = new Set();
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        set.add(el);
      });
    });
    // also add any element that contains the ₹ sign
    document.querySelectorAll('body *').forEach(function (el) {
      // skip script/style etc
      if (el.children.length === 0 && el.textContent && el.textContent.indexOf('₹') !== -1) {
        set.add(el);
      }
    });
    return Array.from(set);
  }

  function applyIndianFormatToAll() {
    var els = collectElements();
    els.forEach(function (el) {
      indianizeElement(el);
    });
  }

  // debounce helper
  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments,
        ctx = this;
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  var debouncedApply = debounce(applyIndianFormatToAll, 150);

  // Run on DOMContentLoaded and also immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      applyIndianFormatToAll();
    });
  } else {
    applyIndianFormatToAll();
  }

  // Observe changes so dynamic updates (variant selects, ajax) are handled
  var observer = new MutationObserver(debouncedApply);
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });

  // Expose a function for manual testing in console
  window.formatIndianPrices = applyIndianFormatToAll;
})();

document.addEventListener("DOMContentLoaded", () => {
  const wrapper = document.querySelector(".home .rich-text-wrap");
  if (!wrapper) return;

  const heading = wrapper.querySelector(".pro-subtext h3");
  if (!heading) return;

  const nodes = [...heading.childNodes];
  heading.innerHTML = "";

  // Keep <br> and split letters
  nodes.forEach(node => {
    if (node.nodeName === "BR") {
      heading.appendChild(document.createElement("br"));
      return;
    }
    if (node.nodeType === Node.TEXT_NODE) {
      node.textContent.split("").forEach(char => {
        const span = document.createElement("span");
        span.className = "char";
        span.textContent = char === " " ? " " : char;
        heading.appendChild(span);
      });
    }
  });

  const letters = [...heading.querySelectorAll(".char")];

  window.addEventListener("scroll", () => {
    const rect = wrapper.getBoundingClientRect();
    const winH = window.innerHeight;

    const sectionCenter = rect.top + rect.height / 2;
    const viewportCenter = winH / 2;

    /*
      progress = 0 when section just enters
      progress = 1 when section center hits viewport center
    */
    const progress = Math.min(
      Math.max(
        (viewportCenter - rect.top) / (rect.height / 2 + viewportCenter),
        0
      ),
      1
    );

    // const fillCount = Math.floor(progress * letters.length);
    const fillCount = Math.floor(progress * letters.length * 1.2);

    letters.forEach((letter, index) => {
      letter.style.opacity = index < fillCount ? "1" : "0.4";
    });
  });
});




